export const environment = {
  production: false,
  // apiUrl: "http://localhost:3000/v1/",
  apiUrl: "https://api.one.truventor.com/v1/",
  socketUrl: "wss://api.engage.backend.truventor.com/",
  meetingUrl:"https://api.engage.backend.truventor.com/",
  jitsiDomain: "meet.truventor.com",
  engageApiUrl: "https://api.engage.backend.truventor.com/"
};